var MobileTziros = function() {
    return {
        refresh: function() {
            return Ajax.getTziro(
                MobileTziros.date,
                $('#sort_select_time').hasClass('ii__selected'),
                false,
                function(data) {
                    $('#live_tziros').html(data.html);
                    MatchesTable.applyAllFilters();
                });
        },
        refreshLoop: function() {
            MobileTziros.refresh().finally(function() {
                setTimeout(MobileTziros.refreshLoop, 60 * 1000);
            });
        },
        init: function(date) {
            MobileTziros.date = date;
            setTimeout(MobileTziros.refreshLoop, 60 * 1000);
            $('.ii__sort_select').click(function() {
                $('.ii__sort_select').removeClass('active').removeClass('blue').removeClass('ii__selected');
                $(this).addClass('active').addClass('blue').addClass('ii__selected');
                MobileTziros.refresh();
            });
        }
    };
}();
